// Mui
import List from '@material-ui/core/List'
import Button from '@material-ui/core/Button'
// react
import { useDispatch, useSelector } from 'react-redux'
import { getOrdersHistory } from '../reducks/users/selectors'
import { useEffect, useCallback } from 'react'
import { fetchOrdersHistory } from '../reducks/users/operations'
import { OrderHistoryItem, PrimaryButton } from '../components'
import { push } from 'connected-react-router'
import styled from 'styled-components'
import { Layout } from '../components'

const OrderHistory = () => {
    const dispatch = useDispatch()
    const selector = useSelector(state=>state)
    let orders = getOrdersHistory(selector)
    if (!orders) { orders = [] }

    const backToHome = useCallback(()=>{
        dispatch(push('/'))
    },[dispatch])

    useEffect(() => {
        dispatch(fetchOrdersHistory())
    },[dispatch])

    return (
        <Layout>
            <ListWrapper>
                <div className='spacer-50' />
                <h1 style={{textAlign: 'center'}}>注文履歴</h1>
                <div className='spacer-50' />
                {orders.length === 0 && (
                    <>
                        <div className='spacer-100' />
                            <p>注文履歴が見つかりませんでした。</p>
                        <div className='spacer-100' />
                    </>
                )}
                <List>
                    {orders.length > 0 && (
                        orders.map(order => <OrderHistoryItem order={order} key={order.id} />)
                    )}
                </List>
                <PrimaryButton label='ホームに戻る' operation={backToHome} />
                <div className='spacer-50' />
                <Button onClick={()=>dispatch(push('/mypage'))}>マイページへ戻る</Button>
                <div className='spacer-100' />
            </ListWrapper>
        </Layout>
    )
}

export default OrderHistory

const ListWrapper = styled.div`
    width: 640px;
    margin: 0 auto;
    text-align: center;
    @media screen and (max-width:768px){
        width: 100%;
        padding: 0 20px;
    }
`